// useRBLPrice — Polls /api/shadow/tokens/rbl-price every 60s.
// Returns live price + EUR equivalent + cached/loading flags. Gracefully
// disables R₿L payment options when the price source is unavailable.
import { useEffect, useState } from "react";
import { API } from "../lib/api";

const POLL_MS = 60_000;

export const useRBLPrice = () => {
  const [data, setData] = useState({
    price_usd: null,
    price_eur: null,
    last_updated: null,
    is_cached: false,
    loading: true,
    available: false,   // false when API returns 503 / network error
  });

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const r = await fetch(`${API}/shadow/tokens/rbl-price`);
        if (!r.ok) {
          if (mounted) setData((d) => ({ ...d, loading: false, available: false }));
          return;
        }
        const j = await r.json();
        if (!mounted) return;
        setData({
          price_usd: Number(j?.price_usd || 0),
          price_eur: Number(j?.price_eur || 0),
          last_updated: j?.updated_at || null,
          is_cached: !!j?.is_cached,
          loading: false,
          available: true,
        });
      } catch (_e) {
        if (mounted) setData((d) => ({ ...d, loading: false, available: false }));
      }
    };
    load();
    const t = setInterval(load, POLL_MS);
    return () => { mounted = false; clearInterval(t); };
  }, []);

  return data;
};

export default useRBLPrice;
